var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoOngoingRecordingBlack = function SvgIcoOngoingRecordingBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "2 2 20 20"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    stroke: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9 8h3.096q.61 0 1.153.124.553.113.96.396.418.271.655.746.249.462.249 1.163 0 .847-.44 1.447-.441.587-1.289.745L15.418 16h-2.113l-1.672-3.198h-.87V16H9zm1.763 3.31h1.04q.236 0 .496-.01.271-.024.486-.102.215-.09.35-.271.148-.181.148-.509 0-.304-.125-.486a.8.8 0 0 0-.316-.271 1.3 1.3 0 0 0-.44-.136 4 4 0 0 0-.487-.033h-1.152z"
  })));
};
export default SvgIcoOngoingRecordingBlack;